import log from 'salvo-lite/log'

class Variants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-variants'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('change', () => {
            this._updateUrl(this._elem.value, true)
            this._updateCartAddTrigger(this._elem.value, true)
        })
    }

    _updateUrl (variant, id = false) {
        const variantID = id === true ? variant : variant.id
        const newUrl = `${window.location.origin}${window.location.pathname}?variant=${variantID}`
        window.history.pushState({path: newUrl}, '', newUrl)
    }

    _updateCartAddTrigger (variant, id = false) {
        const variantID = id === true ? variant : variant.id
        const addToCartButton = document.querySelector('[data-cart-update*="add"]')
        const addToCartButtonData = addToCartButton.getAttribute('data-cart-update')
        const addToCartButtonVariantID = addToCartButtonData.split('"variant_id": "')[1].split('"')[0]
        const variantIDToReplace = new RegExp(addToCartButtonVariantID, 'g')
        const newData = addToCartButtonData.replace(variantIDToReplace, variantID)
        addToCartButton.setAttribute('data-cart-update', newData)
    }
}

export default Variants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js